export async function GetEmployeesApi(params = {}) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);
    if (params.search) queryParams.append('search', params.search);
    if (params.columns) queryParams.append('columns', params.columns);

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "*/*",
        Authorization: token,
      },
    };

    await fetch(
      `${process.env.REACT_APP_API_URL}v1/ehrm/employees?${queryParams.toString()}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error get employees: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
